export * from '@prisma/client';
import { PrismaClient } from '@prisma/client';
var DEFAULT_CONNECTION_LIMIT = '5';
var DEFAULT_POOL_TIMEOUT = '20';
function isPostgresUrl(url) {
    return url.startsWith('postgresql://') || url.startsWith('postgres://');
}
/** Applies Prisma pool defaults when not already set on DATABASE_URL. */
export function resolveDatabaseUrl(rawUrl) {
    var _a, _b;
    var url = rawUrl !== null && rawUrl !== void 0 ? rawUrl : process.env.DATABASE_URL;
    if (!url) {
        return '';
    }
    if (!isPostgresUrl(url)) {
        return url;
    }
    var parsed = new URL(url);
    if (!parsed.searchParams.has('connection_limit')) {
        parsed.searchParams.set('connection_limit', (_a = process.env.DATABASE_CONNECTION_LIMIT) !== null && _a !== void 0 ? _a : DEFAULT_CONNECTION_LIMIT);
    }
    if (!parsed.searchParams.has('pool_timeout')) {
        parsed.searchParams.set('pool_timeout', (_b = process.env.DATABASE_POOL_TIMEOUT) !== null && _b !== void 0 ? _b : DEFAULT_POOL_TIMEOUT);
    }
    var applicationName = process.env.DATABASE_APPLICATION_NAME;
    if (applicationName && !parsed.searchParams.has('application_name')) {
        parsed.searchParams.set('application_name', applicationName);
    }
    var hasSessionOptions = parsed.searchParams.has('options');
    var base = parsed.toString();
    // Pin the DB session time zone to UTC. Every timestamp is stored in UTC, but
    // raw-SQL filters bind JS `Date`s as `timestamptz`; when the session runs in a
    // non-UTC zone Postgres shifts the stored `timestamp without time zone` values
    // during comparison and leaks rows from the neighbouring local day. Setting
    // the session to UTC makes those comparisons correct everywhere at once.
    // NOTE: `URLSearchParams` encodes the space as `+`, which libpq rejects
    // (`unrecognized configuration parameter "+timezone"`), so append the
    // pre-encoded value manually to keep the required `%20`.
    if (!hasSessionOptions) {
        var separator = base.includes('?') ? '&' : '?';
        return "".concat(base).concat(separator, "options=-c%20timezone%3DUTC");
    }
    return base;
}
var prisma = new PrismaClient({
    datasources: {
        db: {
            url: resolveDatabaseUrl()
        }
    }
});
export { prisma };
